import { SoggettoDto } from "@api/client";
import { serviceGetService } from "common/_redux/service/actions";
import { serviceServiceSelector } from "common/_redux/service/selectors";
import { subjectGetDetails, subjectSetTitolariEffettiviAdded } from "common/_redux/subject/actions";
import { titolariEffettiviAddedSelector } from "common/_redux/subject/selectors";
import BftAccordion from "common/components/accordion";
import BftButton from "common/components/button";
import DettaglioPianoCard from "common/components/dettaglio-piano-card";
import RiepilogoTitolariCard from "common/components/riepilogo-titolari";
import { goToTop } from "common/helpers/common-utils";
import { AppRouterService } from "core/routes/app-router.service";
import { PathEnum } from "core/routes/path.enum";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { layoutStepsSelector } from "layout/_redux/selectors";
import Footer from "layout/components/footer";
import Header from "layout/components/header";
import Sidebar from "layout/components/sidebar";
import Topbar from "layout/components/topbar";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import ContoDiPagamento from "./conto-di-pagamento";
import SceltaPos from "./scelta-pos";

const title = "4. Servizi";
const subtitle =
	"Completa le informazioni richieste e controlla che quelle già inserite siano corrette.";

const FourthStepPage: React.FC = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const location = useLocation();

	const steps = useAppSelector(layoutStepsSelector);
	const service = useAppSelector(serviceServiceSelector);
	const titolariEffettiviStored = useAppSelector(titolariEffettiviAddedSelector);

	const activeAccordionIndex =
		(steps
			?.find((s) => s.route == AppRouterService.get(PathEnum.step4))
			?.subSteps?.findIndex((ss) => ss.route == location.pathname) || 0) + 1;

	const goBack = () => {
		navigate(-1);
	};

	const goNext = () => {
		navigate(AppRouterService.get(PathEnum.step5));
	};

	useEffect(() => {
		if (steps) {
			if (location.pathname == AppRouterService.get(PathEnum.step4)) {
				let nextStep = steps?.find((s) => s.route == AppRouterService.get(PathEnum.step4))
					?.subSteps?.[0]?.route;

				if (!nextStep) {
					console.error("No next step found");
					return;
				}

				navigate(nextStep, { replace: true });
			}

			dispatch(serviceGetService());
		}
	}, [steps]);

	useEffect(() => {
		if (!titolariEffettiviStored) getSubjects();
	}, [titolariEffettiviStored]);

	useEffect(() => {
		setTimeout(() => {
			const id = activeAccordionIndex > 1 ? `accordion-${activeAccordionIndex}` : null;
			goToTop(id);
		}, 300);
	}, [activeAccordionIndex]);

	const getSubjects = () => {
		dispatch(subjectGetDetails())
			.unwrap()
			.then((subjectRes) => {
				if (subjectRes?.elencoTitolariEffettivi?.length) {
					const esponentiMapped = subjectRes.elencoTitolariEffettivi?.map((item: SoggettoDto) => ({
						...item,
						idFE: item.id,
						fulfilled: item.fullfiled,
					}));
					dispatch(
						subjectSetTitolariEffettiviAdded({
							list: esponentiMapped,
						})
					);
				}
			});
	};

	return (
		<>
			<Sidebar />
			<div className="wrapper d-flex flex-column min-vh-100">
				<div className="body flex-grow-1 px-0">
					<Header />
					<Topbar />
					<div className="container-fluid body-section px-0">
						<section>
							<Row>
								<Col sm={12} lg={8}>
									<div>
										<h2 className="mb-3 ms-3">{title}</h2>
										<span className="gray">{subtitle}</span>
									</div>

									{service?.tipoServizio !== "WEB_POS" &&
										service?.tipoServizio !== "ACI" &&
										service?.tipoServizio !== "ADV" &&
										service?.tipoServizio !== "SD" &&
										service?.tipoServizio !== "PAYMENT_FACILITATOR" && (
											<BftAccordion
												title="Conto di pagamento"
												index={1}
												total={2}
												isActive={
													location.pathname == AppRouterService.get(PathEnum.contoPagamento)
												}
												isCompleted={activeAccordionIndex > 1}
											>
												<ContoDiPagamento />
											</BftAccordion>
										)}

									{service?.tipoServizio !== "WEB_POS" &&
									service?.tipoServizio !== "ACI" &&
									service?.tipoServizio !== "ADV" &&
									service?.tipoServizio !== "SD" &&
									service?.tipoServizio !== "PAYMENT_FACILITATOR" ? (
										<BftAccordion
											title="Convenzione POS"
											index={2}
											total={2}
											isActive={location.pathname == AppRouterService.get(PathEnum.pos)}
											isCompleted={activeAccordionIndex > 2}
										>
											<SceltaPos />
										</BftAccordion>
									) : (
										<BftAccordion
											title="Convenzione POS"
											index={1}
											total={1}
											isActive={location.pathname == AppRouterService.get(PathEnum.pos)}
											isCompleted={activeAccordionIndex > 1}
										>
											<SceltaPos />
										</BftAccordion>
									)}

									<Row className="justify-content-between mx-1">
										<Col xs={1}>
											<BftButton className="btn-buffetti-secondary px-3" onClick={() => goBack()}>
												<i className="fas fa-arrow-left"></i>
											</BftButton>
										</Col>
										{service?.tipoServizio !== "WEB_POS" &&
										service?.tipoServizio !== "ACI" &&
										service?.tipoServizio !== "ADV" &&
										service?.tipoServizio !== "SD" &&
										service?.tipoServizio !== "PAYMENT_FACILITATOR" ? (
											<Col xs={10} md={11}>
												<BftButton
													className="btn-buffetti col-12"
													isDisabled={activeAccordionIndex <= 2}
													onClick={() => goNext()}
												>
													Vai allo step successivo
												</BftButton>
											</Col>
										) : (
											<Col xs={10} md={11}>
												<BftButton
													className="btn-buffetti col-12"
													isDisabled={activeAccordionIndex <= 1}
													onClick={() => goNext()}
												>
													Vai allo step successivo
												</BftButton>
											</Col>
										)}
									</Row>
								</Col>
								<Col sm={12} md={4} className="side-card">
									<DettaglioPianoCard />
									<RiepilogoTitolariCard />
								</Col>
							</Row>
						</section>
					</div>
				</div>
				<Footer />
			</div>
		</>
	);
};

export default FourthStepPage;
